import throttle from './helper/throttle';
import getWaterMarker from './image-utils/water-marker';
import { copy } from './browser/copy';
import { reportExp } from './log-utils/report';
import initLog from './log-utils/initLog';
import { injectCookieForBabelLogin } from './helper/babel.utils';
import emptyFn from './helper/emptyFn';
import batchedUpdates from './helper/batched-updates';
import { removeInvalidKey } from './helper/invalid';

import toLogin, { toLogout, loginStateExpiress, loginType, afterLoginFailed } from './browser/toLogin';

import { formatPrice, isNumber, thousands, formatSearchPrice, formatNumber } from './format-number/format-number';
import {
  yuan2fen,
  fen2yuan,
  addZero,
  format2yuan,
  dotOne,
  formatPriceWithPercent,
  formatPrice2Number,
  sellPriceFormat,
  applyNumFormat,
} from './format-number';
import {
  remainingDayHourMinute,
  formateTimeStamp,
  enhancedFormateTimeStamp,
  remainingDay,
  remainingHours,
  remainingHoursAndMin,
  toDate,
  timeStamp2date,
  formatTimeRange,
  formateTimeStampToSecondPrecision,
} from './format-time';
import {
  isObjShadowEq,
  deepEq,
  getDepartment,
  extractOrganization,
  transformConstantsList,
  getBytesLength,
  stringToHump,
  stringToLine,
} from './helper';
import { getQuery, scrollWindowTo, goto, getResizePercent } from './browser';
import {
  filterConditions,
  formatConditionsToQuery,
  formatUrl,
  formatQueryObj,
  downloadFile,
  parseQuery,
  formatQueryObjNew,
  pushQuery,
} from './url';
import { resizeImg } from './image-utils';
import { beforePicUpload } from './image-utils/image-upload-check';
import './path/index.ts';
import { isEffectArray, isRepeatItem } from './array-utils';

export {
  removeInvalidKey,
  formatPrice,
  formatSearchPrice,
  formatNumber,
  isNumber,
  thousands,
  throttle,
  yuan2fen,
  fen2yuan,
  addZero,
  format2yuan,
  dotOne,
  formatPriceWithPercent,
  formatPrice2Number,
  sellPriceFormat,
  applyNumFormat,
  // 时间
  remainingDayHourMinute,
  formateTimeStamp,
  enhancedFormateTimeStamp,
  remainingDay,
  remainingHours,
  remainingHoursAndMin,
  toDate,
  timeStamp2date,
  formatTimeRange,
  formateTimeStampToSecondPrecision,
  // helper
  stringToHump,
  stringToLine,
  getBytesLength,
  isObjShadowEq,
  deepEq,
  getDepartment,
  extractOrganization,
  transformConstantsList,
  // 浏览器
  getQuery,
  scrollWindowTo,
  goto,
  getResizePercent,
  // url
  parseQuery,
  filterConditions,
  formatConditionsToQuery,
  formatUrl,
  pushQuery,
  formatQueryObj,
  formatQueryObjNew,
  downloadFile,
  resizeImg,
  beforePicUpload,
  getWaterMarker,
  copy,
  reportExp,
  initLog,
  loginType,
  afterLoginFailed,
  toLogin,
  toLogout,
  loginStateExpiress,
  injectCookieForBabelLogin,
  emptyFn,
  batchedUpdates,
  //数组
  isEffectArray,
  isRepeatItem,
};

export default {
  formatTimeRange,
  formateTimeStampToSecondPrecision,
  formateTimeStamp,
  getQuery,
  parseQuery,
  remainingDay,
  yuan2fen,
  fen2yuan,
  toDate,
  addZero,
  transformConstantsList,
  format2yuan,
  timeStamp2date,
  filterConditions,
  thousands,
  deepEq,
  dotOne,
  formatPrice,
  extractOrganization,
  scrollWindowTo,
  formatPriceWithPercent,
  formatPrice2Number,
  enhancedFormateTimeStamp,
  throttle,
  resizeImg,
  beforePicUpload,
  isNumber,
  isObjShadowEq,
  goto,
  sellPriceFormat,
  applyNumFormat,
  formatConditionsToQuery,
  formatUrl,
  pushQuery,
  remainingHours,
  remainingHoursAndMin,
  getResizePercent,
  formatQueryObj,
  formatQueryObjNew,
  downloadFile,
  getWaterMarker,
  copy,
  reportExp,
  initLog,
  toLogin,
  toLogout,
  loginStateExpiress,
  injectCookieForBabelLogin,
  emptyFn,
  batchedUpdates,
  removeInvalidKey,
  //数组
  isEffectArray,
  isRepeatItem,
};
